import React from 'react'

const SuccessIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='176'
            height='154'
            fill='none'
            data-my-extension-installed='true'
            viewBox='0 0 176 154'
        >
            <path
                stroke='#EAEBEB'
                strokeDasharray='4.38 4.38'
                strokeWidth='0.873'
                d='M158.84 84.048c0 38.081-30.872 68.952-68.952 68.952s-68.951-30.871-68.951-68.952c0-38.08 30.87-68.952 68.95-68.952 38.081 0 68.953 30.872 68.953 68.952Z'
                clipRule='evenodd'
            ></path>
            <path
                stroke='#EAEBEB'
                strokeDasharray='4.4 4.4'
                strokeWidth='0.873'
                d='M141.092 84.048c0 28.279-22.925 51.204-51.204 51.204-28.28 0-51.204-22.925-51.204-51.204s22.924-51.204 51.204-51.204c28.279 0 51.204 22.925 51.204 51.204Z'
                clipRule='evenodd'
            ></path>
            <path
                stroke='#1385C8'
                strokeLinecap='round'
                strokeWidth='0.873'
                d='m7.91 93.332-1.28-.04M6.991 90.904l-.918.858M4.6 89.796l-.02 1.252M2.133 90.655l.891.913M1.038 92.98l1.28.039M1.956 95.407l.92-.858M4.349 96.516l.02-1.252M6.816 95.656l-.892-.913M174.861 75.488l-.563.609M172.219 76.017l.425.391M171.791 78.717l.563-.61M174.431 78.187l-.424-.391'
            ></path>
            <path
                fill='#1385C8'
                fillRule='evenodd'
                d='m123.323 3.888-1.361-.037z'
                clipRule='evenodd'
            ></path>
            <path
                stroke='#1385C8'
                strokeLinecap='round'
                strokeWidth='0.873'
                d='m123.323 3.888-1.361-.037'
            ></path>
            <path
                fill='#1385C8'
                fillRule='evenodd'
                d='m119.801.602-.02 1.163z'
                clipRule='evenodd'
            ></path>
            <path
                stroke='#1385C8'
                strokeLinecap='round'
                strokeWidth='0.873'
                d='m119.801.602-.02 1.163'
            ></path>
            <path
                fill='#1385C8'
                fillRule='evenodd'
                d='m116.012 3.56 1.362.037z'
                clipRule='evenodd'
            ></path>
            <path
                stroke='#1385C8'
                strokeLinecap='round'
                strokeWidth='0.873'
                d='m116.012 3.56 1.362.037'
            ></path>
            <path
                fill='#1385C8'
                fillRule='evenodd'
                d='m119.534 6.847.021-1.164z'
                clipRule='evenodd'
            ></path>
            <path
                stroke='#1385C8'
                strokeLinecap='round'
                strokeWidth='0.873'
                d='m119.534 6.847.021-1.164'
            ></path>
            <path
                fill='#1385C8'
                fillRule='evenodd'
                d='M22.52 129.488c-.98.293-2.61 1.732-3.168 3.438-.094-1.585-1.1-3.578-2.208-3.865 1.351-.477 2.815-2.233 3.204-3.713-.07 1.551 1.337 3.802 2.172 4.14M45.455 10.119c-.756.133-2.094 1.063-2.658 2.286.067-1.189-.51-2.76-1.31-3.07 1.048-.239 2.29-1.42 2.708-2.488-.187 1.149.667 2.948 1.26 3.271M145.571 18.75a1.826 1.826 0 1 1 .077-3.651 1.826 1.826 0 0 1-.077 3.65M145.575 138.432a1.591 1.591 0 1 1 .071-3.181 1.591 1.591 0 0 1-.071 3.181'
                clipRule='evenodd'
            ></path>
            <path
                stroke='#1385C8'
                strokeLinecap='round'
                strokeWidth='0.873'
                d='M13.542 42.989a.984.984 0 1 1 .043-1.968.984.984 0 0 1-.043 1.968Z'
                clipRule='evenodd'
            ></path>
            <path
                fill='#fff'
                d='m47.445 82.475 54.968-31.583zM60.52 103.189l54.967-31.582zM129.567 63.67l4.284-2.494zM79.912 120.23l41.746-24.383z'
                opacity='0.5'
            ></path>
            <path
                fill='#E7ECF2'
                d='M89.612 51.18c17.624 0 31.934 14.19 31.934 31.667s-14.31 31.667-31.934 31.667-31.935-14.19-31.935-31.667c0-17.476 14.31-31.666 31.935-31.666'
            ></path>
            <path
                fill='#fff'
                d='M89.612 50.644c17.032 0 30.861 13.709 30.861 30.593s-13.829 30.593-30.861 30.593c-17.033 0-30.862-13.709-30.862-30.593s13.83-30.593 30.862-30.593'
            ></path>
            <path
                fill='#1385C8'
                stroke='#000'
                strokeWidth='2.619'
                d='M122.856 82.847c0-18.21-14.907-32.975-33.244-32.975-18.338 0-33.245 14.765-33.245 32.975s14.907 32.976 33.245 32.976 33.244-14.766 33.244-32.976Z'
            ></path>
            <path
                fill='#fff'
                fillRule='evenodd'
                d='M78.902 80.658a2.056 2.056 0 0 0-2.92.133c-.771.85-.712 2.168.131 2.944l9.732 8.959a2.88 2.88 0 0 0 4.09-.186c.045-.05.045-.05.088-.103l13.888-16.833a2.094 2.094 0 0 0-.267-2.935 2.06 2.06 0 0 0-2.913.27L87.675 88.733z'
                clipRule='evenodd'
            ></path>
        </svg>
    )
}

export default SuccessIcon